/**
 * Call-specific keyboard shortcuts.
 * Only active during a connected call. Suppressed when typing in an input.
 */

import { useEffect } from 'react'
import { useCallStore } from '@/stores/call'

export function useCallKeyboardShortcuts() {
  const status = useCallStore((s) => s.status)

  useEffect(() => {
    if (status !== 'connected') return

    function onKeyDown(e: KeyboardEvent) {
      // Don't intercept when typing in inputs
      const target = e.target as HTMLElement
      if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) return

      const store = useCallStore.getState()

      switch (e.key) {
        case 'm':
          e.preventDefault()
          store.toggleMic()
          break
        case 'v':
          e.preventDefault()
          store.toggleCamera()
          break
        case 'Escape':
          e.preventDefault()
          if (store.videoMode === 'fullscreen') {
            store.setVideoMode('pip')
          } else {
            store.setVideoMode('fullscreen')
          }
          break
      }
    }

    window.addEventListener('keydown', onKeyDown)
    return () => window.removeEventListener('keydown', onKeyDown)
  }, [status])
}
